import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import EmployeeTable from './EmplpoyeeTable';
import {
  getRoleEmployeePermissions,
} from 'src/services/authService';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';

function Employee() {
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState([]);

  const getPermissions = (mail) => {
    getRoleEmployeePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      setPermissions(tabs[0]?.permissions);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Employee Management</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <EmployeeTable permissions={permissions} />
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
}

export default Employee;
